import { render, staticRenderFns } from "./QuestionContainer.vue?vue&type=template&id=129c397d&"
import script from "./QuestionContainer.vue?vue&type=script&lang=js&"
export * from "./QuestionContainer.vue?vue&type=script&lang=js&"
import style0 from "./QuestionContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports